import React from 'react';

const Footer = () => {
    return (
        <p style={{ backgroundColor: 'red' }} className='footer'>&copy; {new Date().getFullYear()} Property Bhopal. All Rights Reserved.</p>
    )
}
export default Footer;